(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about-moissanite"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const button = event.target.closest('.about-moissanite__read-more');
    if (!button) return;
    const wrapper = button.closest('.about-moissanite__content');
    if (!wrapper) return;
    const expanded = wrapper.classList.toggle('is-expanded');
    button.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    const label = button.querySelector('.about-moissanite__read-more-label');
    if (label) label.textContent = expanded ? 'Read less' : 'Read more';
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brand-quality"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const button = event.target.closest('.brand-quality__read-more');
    if (!button) return;
    const wrapper = button.closest('.brand-quality__inner');
    if (!wrapper) return;
    const expanded = wrapper.classList.toggle('is-expanded');
    button.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    const label = button.querySelector('.brand-quality__read-more-label');
    if (label) label.textContent = expanded ? 'Read less' : 'Read more';
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-inquiries"] && !Shopify.designMode) return;
  try {
    
  (() => {
    class CustomInquiriesStepper extends HTMLElement {
      connectedCallback() {
        const nameField = this.querySelector('#ContactForm-name');
        const nameLabel = this.querySelector('label[for="ContactForm-name"]');
        const emailField = this.querySelector('#ContactForm-email');
        const emailLabel = this.querySelector('label[for="ContactForm-email"]');
        const phoneField = this.querySelector('#ContactForm-phone');
        const phoneLabel = this.querySelector('label[for="ContactForm-phone"]');
        const bodyField = this.querySelector('#ContactForm-body');
        const bodyLabel = this.querySelector('label[for="ContactForm-body"]');
        const submitButton = this.querySelector('.submit-button');
        const backButton = this.querySelector('.custom-inquiries__nav-button--back');
        const nextButton = this.querySelector('.custom-inquiries__nav-button--next');
        const progressText = this.querySelector('.custom-inquiries__progress-text');
        const dots = Array.from(this.querySelectorAll('.custom-inquiries__dot'));
        const successEl = this.querySelector('.contact-form__success');
        const errorEl = this.querySelector('.contact-form__error');

        // Safety: if the native form's structure ever changes, bail out and let
        // every field show normally rather than risk hiding something permanently.
        if (!nameField || !emailField || !bodyField || !submitButton) return;

        // After a real submit (success or error), don't hide anything - show the
        // full form plus the native confirmation/error message exactly as-is.
        if (successEl || errorEl) {
          const nav = this.querySelector('.custom-inquiries__nav');
          const progress = this.querySelector('.custom-inquiries__progress');
          if (nav) nav.hidden = true;
          if (progress) progress.hidden = true;
          return;
        }

        const steps = [
          [nameLabel, nameField].filter(Boolean),
          [emailLabel, emailField].filter(Boolean),
          [phoneLabel, phoneField, bodyLabel, bodyField, submitButton].filter(Boolean),
        ];

        let current = 0;

        const render = () => {
          steps.forEach((elements, index) => {
            elements.forEach((el) => {
              el.style.display = index === current ? '' : 'none';
            });
          });

          backButton.hidden = current === 0;
          nextButton.hidden = current === steps.length - 1;

          if (progressText) progressText.textContent = `Step ${current + 1} of ${steps.length}`;
          dots.forEach((dot, index) => dot.classList.toggle('is-active', index === current));
        };

        nextButton.addEventListener('click', () => {
          if (current === 1) {
            if (!emailField.checkValidity() || emailField.value.trim() === '') {
              emailField.reportValidity();
              return;
            }
          }
          current = Math.min(current + 1, steps.length - 1);
          render();
        });

        backButton.addEventListener('click', () => {
          current = Math.max(current - 1, 0);
          render();
        });

        render();
      }
    }

    if (!customElements.get('custom-inquiries-stepper')) {
      customElements.define('custom-inquiries-stepper', CustomInquiriesStepper);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-categories"] && !Shopify.designMode) return;
  try {
    
  (() => {
    class FeaturedCategories extends HTMLElement {
      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('.featured-categories__slide'));
        this.dots = Array.from(this.querySelectorAll('.featured-categories__dot'));
        this.prevBtn = this.querySelector('.featured-categories__arrow--prev');
        this.nextBtn = this.querySelector('.featured-categories__arrow--next');
        this.count = this.slides.length;
        this.active = 0;
        this.autoplayMs = parseInt(this.dataset.autoplayMs, 10) || 4500;
        this.timer = null;
        this.touchStartX = null;

        this.dots.forEach((dot, i) => {
          dot.addEventListener('click', () => this.goTo(i));
        });

        // Mobile shows the previous/next slides faintly: tapping one brings it to the centre instead of following its link
        this.slides.forEach((slide, i) => {
          slide.addEventListener('click', (event) => {
            if (i === this.active) return;
            event.preventDefault();
            this.goTo(i);
          });
        });

        if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.goTo(this.active - 1));
        if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.goTo(this.active + 1));

        this.addEventListener('mouseenter', () => this.stopAutoplay());
        this.addEventListener('mouseleave', () => this.startAutoplay());
        this.addEventListener('focusin', () => this.stopAutoplay());
        this.addEventListener('focusout', () => this.startAutoplay());

        this.addEventListener(
          'touchstart',
          (event) => {
            this.touchStartX = event.touches[0].clientX;
            this.stopAutoplay();
          },
          { passive: true }
        );
        this.addEventListener(
          'touchend',
          (event) => {
            if (this.touchStartX === null) return;
            const delta = event.changedTouches[0].clientX - this.touchStartX;
            if (Math.abs(delta) > 40) {
              this.goTo(this.active + (delta < 0 ? 1 : -1));
            }
            this.touchStartX = null;
            this.startAutoplay();
          },
          { passive: true }
        );

        this.render();
        this.startAutoplay();
      }

      disconnectedCallback() {
        this.stopAutoplay();
      }

      goTo(index) {
        if (this.count === 0) return;
        this.active = ((index % this.count) + this.count) % this.count;
        this.render();
      }

      render() {
        this.slides.forEach((slide, i) => {
          const isActive = i === this.active;
          // Position relative to the active slide (shortest way round the loop), used by the mobile peek layout
          let offset = i - this.active;
          if (offset > this.count / 2) offset -= this.count;
          if (offset < -this.count / 2) offset += this.count;
          slide.style.setProperty('--offset', String(offset));
          slide.style.setProperty('--abs-offset', String(Math.min(Math.abs(offset), 3)));
          slide.classList.toggle('is-active', isActive);
          slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');

          const button = slide.querySelector('.featured-categories__button');
          if (button) button.setAttribute('tabindex', isActive ? '0' : '-1');
        });

        this.dots.forEach((dot, i) => {
          const isActive = i === this.active;
          dot.classList.toggle('is-active', isActive);
          dot.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });
      }

      startAutoplay() {
        this.stopAutoplay();
        if (this.count <= 1) return;
        this.timer = window.setInterval(() => this.goTo(this.active + 1), this.autoplayMs);
      }

      stopAutoplay() {
        if (this.timer) {
          window.clearInterval(this.timer);
          this.timer = null;
        }
      }
    }

    if (!customElements.get('featured-categories')) {
      customElements.define('featured-categories', FeaturedCategories);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.hero__scroll-indicator').forEach((button) => {
      button.addEventListener('click', () => {
        const heroWrapper = button.closest('.hero-wrapper');
        const nextSection = heroWrapper?.nextElementSibling;
        if (nextSection instanceof HTMLElement) {
          nextSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });

    // Phones: the indicator hangs a fixed distance below the buttons. On short screens that can run past the hero's
    // bottom edge (the container clips overflow), so grow the hero by exactly the missing amount. Padding and
    // min-height grow together, so the free space - and the headline/buttons position - stays the same.
    const phone = window.matchMedia('(max-width: 749px)');
    const BOUNCE = 6;
    const SPARE = 12;
    const fit = () => {
      document.querySelectorAll('.hero__scroll-anchor .hero__scroll-indicator').forEach((indicator) => {
        const container = indicator.closest('.hero__container');
        if (!container) return;
        container.style.removeProperty('padding-bottom');
        container.style.removeProperty('min-height');
        if (!phone.matches) return;
        const anchorTop = indicator.parentElement.getBoundingClientRect().top;
        const needed = anchorTop + indicator.offsetTop + indicator.offsetHeight + BOUNCE + SPARE - container.getBoundingClientRect().bottom;
        if (needed <= 0) return;
        const style = getComputedStyle(container);
        container.style.paddingBottom = `${parseFloat(style.paddingBottom) + needed}px`;
        if (style.boxSizing === 'border-box' && !Number.isNaN(parseFloat(style.minHeight))) container.style.minHeight = `${parseFloat(style.minHeight) + needed}px`;
      });
    };
    let frame = 0;
    const schedule = () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(fit);
    };
    fit();
    window.addEventListener('resize', schedule);
    window.addEventListener('load', schedule);
    document.fonts?.ready.then(schedule);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-showcase-3d"] && !Shopify.designMode) return;
  try {
    
  (() => {
    class ProductShowcase3D extends HTMLElement {
      connectedCallback() {
        this.panels = Array.from(this.querySelectorAll('.product-showcase-3d__panel'));
        this.dots = Array.from(this.querySelectorAll('.product-showcase-3d__dot'));
        this.prevBtn = this.querySelector('.product-showcase-3d__arrow--prev');
        this.nextBtn = this.querySelector('.product-showcase-3d__arrow--next');
        this.count = this.panels.length;
        this.active = 0;
        this.autoplayMs = parseInt(this.dataset.autoplayMs, 10) || 4500;
        this.timer = null;
        this.touchStartX = null;

        this.panels.forEach((panel, i) => {
          panel.addEventListener('click', (event) => {
            if (i === this.active) return;
            event.preventDefault();
            this.goTo(i);
          });
        });

        this.dots.forEach((dot, i) => {
          dot.addEventListener('click', () => this.goTo(i));
        });

        if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.goTo(this.active - 1));
        if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.goTo(this.active + 1));

        this.addEventListener('mouseenter', () => this.stopAutoplay());
        this.addEventListener('mouseleave', () => this.startAutoplay());
        this.addEventListener('focusin', () => this.stopAutoplay());
        this.addEventListener('focusout', () => this.startAutoplay());

        this.addEventListener(
          'touchstart',
          (event) => {
            this.touchStartX = event.touches[0].clientX;
            this.stopAutoplay();
          },
          { passive: true }
        );
        this.addEventListener(
          'touchend',
          (event) => {
            if (this.touchStartX === null) return;
            const delta = event.changedTouches[0].clientX - this.touchStartX;
            if (Math.abs(delta) > 40) {
              this.goTo(this.active + (delta < 0 ? 1 : -1));
            }
            this.touchStartX = null;
            this.startAutoplay();
          },
          { passive: true }
        );

        this.render();
        this.startAutoplay();
      }

      disconnectedCallback() {
        this.stopAutoplay();
      }

      goTo(index) {
        if (this.count === 0) return;
        this.active = ((index % this.count) + this.count) % this.count;
        this.render();
      }

      render() {
        this.panels.forEach((panel, i) => {
          let offset = i - this.active;
          if (offset > this.count / 2) offset -= this.count;
          if (offset < -this.count / 2) offset += this.count;
          const absOffset = Math.min(Math.abs(offset), 3);
          panel.style.setProperty('--offset', String(offset));
          panel.style.setProperty('--abs-offset', String(absOffset));
          panel.style.pointerEvents = absOffset > 2.5 ? 'none' : '';

          const isActive = i === this.active;
          panel.classList.toggle('is-active', isActive);
          panel.setAttribute('aria-hidden', isActive ? 'false' : 'true');

          const button = panel.querySelector('.product-showcase-3d__button');
          if (button) button.setAttribute('tabindex', isActive ? '0' : '-1');
        });

        this.dots.forEach((dot, i) => {
          const isActive = i === this.active;
          dot.classList.toggle('is-active', isActive);
          dot.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });
      }

      startAutoplay() {
        this.stopAutoplay();
        if (this.count <= 1) return;
        this.timer = window.setInterval(() => this.goTo(this.active + 1), this.autoplayMs);
      }

      stopAutoplay() {
        if (this.timer) {
          window.clearInterval(this.timer);
          this.timer = null;
        }
      }
    }

    if (!customElements.get('product-showcase-3d')) {
      customElements.define('product-showcase-3d', ProductShowcase3D);
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
